import { ChangeEvent, ComponentProps, useState } from "react";
import { buildURL, validateURL } from "@remo-co/url";
import { Input } from "../Input";

type Props = {
  errorMessage: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
} & ComponentProps<typeof Input>;

const UrlInput = ({ onChange, value, errorMessage, ...rest }: Props) => {
  const [url, setUrl] = useState<string>(value);
  const isValid = url ? validateURL(url) : true;

  const error = isValid ? false : errorMessage;

  const handleBlur = () => setUrl(buildURL(url));
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
    onChange(e);
  };

  return (
    <Input
      {...rest}
      size="sm"
      error={error}
      onBlur={handleBlur}
      onChange={handleChange}
      value={url}
    />
  );
};

export default UrlInput;
